import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toJS} from "../hocs/toJs";
import * as actions from "../../actions";
import _ from 'lodash';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";

import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import moment from "moment";

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

class ScoreRecordInfo extends Component{

  componentDidMount(){
    this.props.getScoreRecordById({
      id: this.props.scoreRecordId,
      filter: {
        include: {
          relation: 'scores',
          scope: {
            include: ['store', 'criteria']
          }
        }
      }
    })
  }

  _findScoreByStoreAndCriterion = (storeId, criterionId) => {
    if(!this.props.scoreRecord.scores) {return ''}
    const score = _.find(this.props.scoreRecord.scores, score => {
      return ((storeId === score.storeId) && (criterionId === score.criteriaId))
    });
    if(score !== null && score !== undefined) {return score.scoreValue}
    return '';
  };

  render(){
    let scoresUniqByCriteria = [];
    let scoresUniqByStores = [];
    if(this.props.scoreRecord.scores){
      scoresUniqByCriteria = _.uniqBy(this.props.scoreRecord.scores, 'criteriaId');
      scoresUniqByStores = _.uniqBy(this.props.scoreRecord.scores, 'storeId');
    }
    if(scoresUniqByCriteria.length === 0 && scoresUniqByStores.length === 0){
      return (
        <div>
          <Typography variant="subheading">
            Empty score record
          </Typography>
        </div>
      )
    }
    return (
      <div>
        <div className={'table-responsive'}>
          <Table className={'table-sm compact'}>
            <TableHead>
              <TableRow>
                <TableCell scope={'column'}/>
                {scoresUniqByCriteria.map(score => (<TableCell key={score.criteriaId}>{score.criteria.name}</TableCell>))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                scoresUniqByStores.map(scoreStore => {
                  return (
                    <TableRow key={scoreStore.storeId}>
                      <TableCell scope={'row'}>
                        <Tooltip
                          disableFocusListener
                          title={<ul className={'ul__style_less'}>
                            <li>{'Id code: ' + scoreStore.store.dwId}</li>
                            <li>{'Entersoft code: ' + scoreStore.store.enterSoftCode}</li>
                            <li>{'Open date: ' + moment(scoreStore.store.openDate).format('DD/MM/YYYY HH:mm:ss')}</li>
                          </ul>}
                        >
                          <span>{scoreStore.store.name}</span>
                        </Tooltip>
                      </TableCell>
                      {
                        scoresUniqByCriteria.map(scoreCriteria => {
                          return (
                            <TableCell scope={'row'} key={scoreCriteria.criteriaId}>
                              {this._findScoreByStoreAndCriterion(scoreStore.storeId, scoreCriteria.criteriaId)}
                            </TableCell>
                          )
                        })
                      }
                    </TableRow>
                  )
                })
              }
            </TableBody>
          </Table>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    scoreRecord: state.scoreRecord.get('scoreRecord')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getScoreRecordById: (payload) => {
      dispatch(actions.getScoreRecordById(payload))
    },
  }
};

export default (connect(mapStateToProps, mapDispatchToProps)(toJS(ScoreRecordInfo)))



// WEBPACK FOOTER //
// ./src/components/scoreRecord/scoreRecordInfo.js